import type {
  PreparedVoiceCommand,
  VarzaVoiceCommand,
  VoiceManifest,
} from '../../ai/local/types/LocalAiTypes';
import { apiRequest } from './http';

export interface VoiceEntityResolution {
  status: 'resolved' | 'multiple' | 'notFound' | 'forbidden';
  items: readonly { id: string; displayName: string; secondaryText?: string }[];
}

function jsonRequest(method: 'POST', body?: unknown): RequestInit {
  return {
    method,
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  };
}

export const voiceApi = {
  manifest(): Promise<VoiceManifest> {
    return apiRequest<VoiceManifest>('/voice/manifest');
  },

  resolve(entityType: string, query: string, limit = 5): Promise<VoiceEntityResolution> {
    return apiRequest<VoiceEntityResolution>(
      '/voice/entities/resolve',
      jsonRequest('POST', { entityType, query, limit }),
    );
  },

  prepare(command: VarzaVoiceCommand): Promise<PreparedVoiceCommand> {
    return apiRequest<PreparedVoiceCommand>('/voice/commands/prepare', jsonRequest('POST', command));
  },

  execute(commandId: string): Promise<PreparedVoiceCommand> {
    return apiRequest<PreparedVoiceCommand>(`/voice/commands/${encodeURIComponent(commandId)}/execute`, jsonRequest('POST'));
  },

  cancel(commandId: string): Promise<void> {
    return apiRequest<void>(`/voice/commands/${encodeURIComponent(commandId)}/cancel`, jsonRequest('POST'));
  },
};
